module.exports = __webpack_public_path__ + "img/27_44.276ee5ce.png";